import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconFileReport = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.3333 3H13.5554C13.7617 3 13.9595 3.0862 14.1054 3.23964L18.772 8.14873C18.9178 8.30217 18.9998 8.51028 18.9998 8.72727V18.5455C18.9998 19.9011 17.9551 21 16.6665 21H7.3333C6.04465 21 5 19.9011 5 18.5455V5.45455C5 4.09894 6.04465 3 7.3333 3ZM17.4439 9.06702L13.2321 4.63634H7.33294C6.90339 4.63634 6.55518 5.00265 6.55518 5.45452V18.5454C6.55518 18.9973 6.90339 19.3636 7.33294 19.3636H16.6661C17.0957 19.3636 17.4439 18.9973 17.4439 18.5454V9.06702Z"
        />
        <path d="M13.5556 3C13.9494 3 14.2748 3.3078 14.3263 3.70716L14.3334 3.81818L14.3334 7.90909H18.2222C18.6159 7.90909 18.9414 8.2169 18.9929 8.61625L19 8.72727C19 9.14149 18.7074 9.48381 18.3277 9.53799L18.2222 9.54545H13.5556C13.1618 9.54545 12.8364 9.23765 12.7849 8.8383L12.7778 8.72727V3.81818C12.7778 3.36631 13.126 3 13.5556 3Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7126 12.2142C15.6851 11.9656 15.4844 11.7727 15.2407 11.7727H13.3405V12.7722H14.0947L12.2332 14.7305L10.9856 13.4181L10.9408 13.3765C10.7544 13.2241 10.485 13.238 10.3137 13.4181L7.93848 15.9168L8.6103 16.6235L10.6493 14.4781L11.8972 15.7906L11.942 15.8322C12.1284 15.9846 12.3978 15.9708 12.5691 15.7906L14.7656 13.48L14.7657 14.2714H15.7158V12.2724L15.7126 12.2142Z"
        />
      </svg>
    );
  }
);
